// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cl-chart-modal-widget[data-v-78b073f5] {
  margin: auto;
  max-width: 1002px;
  padding: 15px;
}
#cl-chart-modal-widget .tab-nav[data-v-78b073f5] {
  display: flex;
  margin: 10px 0px;
  padding-bottom: 10px;
  border-bottom: 1px solid gray;
  font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
}
#cl-chart-modal-widget .tab-nav a[data-v-78b073f5] {
  line-height: 30px;
}
#cl-chart-modal-widget .tab-nav a.selected-tab[data-v-78b073f5] {
  color: black;
  text-decoration: none;
}
#cl-chart-modal-widget .tab-nav a.selected-tab[data-v-78b073f5]:hover {
  text-decoration: none;
}
#cl-chart-modal-widget .tab-nav span[data-v-78b073f5] {
  padding-right: 5px;
  padding-left: 5px;
  line-height: 30px;
}
#cl-chart-modal-widget .close-button[data-v-78b073f5] {
  margin-left: auto;
  height: 30px;
  background-color: #fff;
  border: none;
  color: #000;
  font-size: 21px;
  font-weight: 700;
  opacity: 0.2;
}
#cl-chart-modal-widget .select-nav-container[data-v-78b073f5] {
  border-bottom: 1px solid #999;
  display: none;
  padding: 20px 0;
}
#cl-chart-modal-widget .select-nav-container .select-nav[data-v-78b073f5] {
  border: 1px solid #ccc;
  color: #333;
  font-family: Avenir Next LT W01 Demi, Arial, sans-serif;
  height: 30px;
  max-width: 70%;
  padding: 4px 6px;
  width: 220px;
}
#cl-chart-modal-widget .select-nav-container .close-button[data-v-78b073f5] {
  float: right;
}
#cl-chart-modal-widget .select-nav-container .close-link[data-v-78b073f5] {
  float: right;
  line-height: 32.5px;
}
@media (max-width: 480px) {
#cl-chart-modal-widget .tab-nav[data-v-78b073f5] {
    display: none;
}
#cl-chart-modal-widget .select-nav-container[data-v-78b073f5] {
    display: block;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/charts-modal/ChartsModalContent.vue","webpack://./ChartsModalContent.vue"],"names":[],"mappings":"AACA;EACC,YAAA;EACA,iBAAA;EACA,aAAA;ACAD;ADHA;EAME,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;EACA,uDAAA;ACAF;ADVA;EAYG,iBAAA;ACCH;ADAG;EACC,YAAA;EACA,qBAAA;ACEJ;ADDI;EACC,qBAAA;ACGL;ADpBA;EAsBG,kBAAA;EACA,iBAAA;EACA,iBAAA;ACCH;ADzBA;EA4BE,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;ACAF;ADnCA;EAsCE,6BAAA;EACA,aAAA;EACA,eAAA;ACAF;ADxCA;EA0CG,sBAAA;EACA,WAAA;EACA,uDAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;ACCH;ADjDA;EAmDG,YAAA;ACCH;ADpDA;EAsDG,YAAA;EACA,mBAAA;ACCH;ADEC;AAAA;IAEE,aAAA;ACAD;ADFD;IAKE,cAAA;ACAD;AACF","sourcesContent":["\n#cl-chart-modal-widget {\n\tmargin: auto;\n\tmax-width: 1002px;\n\tpadding: 15px;\n\t.tab-nav {\n\t\t@height: 30px;\n\t\tdisplay: flex;\n\t\tmargin: 10px 0px;\n\t\tpadding-bottom: 10px;\n\t\tborder-bottom: 1px solid gray;\n\t\tfont-family: Avenir Next LT W01 Demi, Arial, sans-serif;\n\t\ta {\n\t\t\tline-height: @height;\n\t\t\t&.selected-tab {\n\t\t\t\tcolor: black;\n\t\t\t\ttext-decoration: none;\n\t\t\t\t&:hover {\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tspan {\n\t\t\tpadding-right: 5px;\n\t\t\tpadding-left: 5px;\n\t\t\tline-height: @height;\n\t\t}\n\t}\n\t.close-button {\n\t\tmargin-left: auto;\n\t\theight: 30px;\n\t\tbackground-color: #fff;\n\t\tborder: none;\n\t\tcolor: #000;\n\t\tfont-size: 21px;\n\t\tfont-weight: 700;\n\t\topacity: 0.2;\n\t}\n\t.select-nav-container {\n\t\tborder-bottom: 1px solid #999;\n\t\tdisplay: none;\n\t\tpadding: 20px 0;\n\t\t.select-nav {\n\t\t\tborder: 1px solid #ccc;\n\t\t\tcolor: #333;\n\t\t\tfont-family: Avenir Next LT W01 Demi, Arial, sans-serif;\n\t\t\theight: 30px;\n\t\t\tmax-width: 70%;\n\t\t\tpadding: 4px 6px;\n\t\t\twidth: 220px;\n\t\t}\n\t\t.close-button {\n\t\t\tfloat: right;\n\t\t}\n\t\t.close-link {\n\t\t\tfloat: right;\n\t\t\tline-height: 32.5px;\n\t\t}\n\t}\n\t@media (max-width: 480px) {\n\t\t.tab-nav {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.select-nav-container {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n","#cl-chart-modal-widget {\n  margin: auto;\n  max-width: 1002px;\n  padding: 15px;\n}\n#cl-chart-modal-widget .tab-nav {\n  display: flex;\n  margin: 10px 0px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid gray;\n  font-family: Avenir Next LT W01 Demi, Arial, sans-serif;\n}\n#cl-chart-modal-widget .tab-nav a {\n  line-height: 30px;\n}\n#cl-chart-modal-widget .tab-nav a.selected-tab {\n  color: black;\n  text-decoration: none;\n}\n#cl-chart-modal-widget .tab-nav a.selected-tab:hover {\n  text-decoration: none;\n}\n#cl-chart-modal-widget .tab-nav span {\n  padding-right: 5px;\n  padding-left: 5px;\n  line-height: 30px;\n}\n#cl-chart-modal-widget .close-button {\n  margin-left: auto;\n  height: 30px;\n  background-color: #fff;\n  border: none;\n  color: #000;\n  font-size: 21px;\n  font-weight: 700;\n  opacity: 0.2;\n}\n#cl-chart-modal-widget .select-nav-container {\n  border-bottom: 1px solid #999;\n  display: none;\n  padding: 20px 0;\n}\n#cl-chart-modal-widget .select-nav-container .select-nav {\n  border: 1px solid #ccc;\n  color: #333;\n  font-family: Avenir Next LT W01 Demi, Arial, sans-serif;\n  height: 30px;\n  max-width: 70%;\n  padding: 4px 6px;\n  width: 220px;\n}\n#cl-chart-modal-widget .select-nav-container .close-button {\n  float: right;\n}\n#cl-chart-modal-widget .select-nav-container .close-link {\n  float: right;\n  line-height: 32.5px;\n}\n@media (max-width: 480px) {\n  #cl-chart-modal-widget .tab-nav {\n    display: none;\n  }\n  #cl-chart-modal-widget .select-nav-container {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
